import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import vSelect from 'vue-select';
import './assets/css/main.css';
import 'vue-select/dist/vue-select.css';
import { router } from '@/plugins/router';
import { createBootstrap } from 'bootstrap-vue-next';
import * as BootstrapVueNext from 'bootstrap-vue-next';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import LoadingPlugin from 'vue-loading-overlay';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import DownloadExcel from 'vue3-json-excel';
import { Form, Field, ErrorMessage } from 'vee-validate';
import { vBToggle, vBTooltip } from 'bootstrap-vue-next';
import { MsalPlugin, DevMsalPlugin } from '@/plugins/msal-plugin';

const toastOptions = {
  position: 'bottom-right',
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: 'button',
  icon: true,
  rtl: false,
};

export const DEBUG = import.meta.env.VITE_DEBUG ? parseInt(import.meta.env.VITE_DEBUG) : 0;
export const MAILTO = import.meta.env.VITE_ADMIN_EMAIL;
export const VERSION = import.meta.env.VITE_APP_VERSION;
console.log(`Loading version ${VERSION}`);
export const AZURE_TENANT = import.meta.env.VITE_AZURE_TENANT;
export const AZURE_AUTHORITY = import.meta.env.VITE_AZURE_AUTHORITY;
export const AZURE_PASSWORD = import.meta.env.VITE_AZURE_PASSWORD_RESET_AUTHORITY;
export const AZURE_KNOWN = import.meta.env.VITE_AZURE_KNOWN;
export const AZURE_CLIENT_ID = import.meta.env.VITE_AZURE_CLIENT_ID;
export const AZURE_SCOPES = import.meta.env.VITE_AZURE_SCOPES;
export const AZURE_REDIRECT_LOGIN =
  import.meta.env.VITE_AZURE_REDIRECT_LOGIN ?? import.meta.env.BASE_URL;
export const AZURE_REDIRECT_LOGOUT =
  import.meta.env.VITE_AZURE_REDIRECT_LOGOUT ?? import.meta.env.BASE_URL;

const msal_options = {
  clientId: AZURE_CLIENT_ID,
  loginAuthority: AZURE_AUTHORITY,
  passwordAuthority: AZURE_PASSWORD,
  knownAuthority: AZURE_KNOWN,
  scopes: AZURE_SCOPES,
  loginUri: AZURE_REDIRECT_LOGIN,
  logoutUri: AZURE_REDIRECT_LOGOUT,
};

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(createBootstrap());
app.use(LoadingPlugin);
app.use(Toast, toastOptions);

// Register all bootstrap-vue-next components globally
Object.entries(BootstrapVueNext).forEach(([name, component]) => {
  if (
    name.startsWith('B') &&
    typeof component === 'object' &&
    component !== null &&
    'setup' in component
  ) {
    app.component(name, component as any);
  }
});

app.component('VSelect', vSelect);
app.component('DownloadExcel', DownloadExcel.Vue3JsonExcel);
app.component('VForm', Form);
app.component('VField', Field);
app.component('VErrorMessage', ErrorMessage);

app.directive('b-toggle', vBToggle);
app.directive('b-tooltip', vBTooltip);

const msalPlugin =
  import.meta.env.VITE_AUTH_DISABLED === 'true' ? new DevMsalPlugin() : new MsalPlugin();

msalPlugin.install(app, msal_options).then(() => {
  app.mount('#app');
});
